import { AvailableIntegrations } from "./OrganisationModels";

export enum ContactType {
  Supplier = "Supplier",
  Customer = "Customer",
  SupplierCustomer = "SupplierCustomer",
  Unknown = "Unknown",
}

export type ContactModel = {
  id: string;
  emails: string[];
  link?: string;
  type: ContactType;
  accountNumber?: string;
  companyName: string;
  contactName: string;
  integration: AvailableIntegrations;
  defaultUserId: string | null;
};

export type EmailContactModel = ContactModel & {
  isSaved: boolean;
};
